<div [ngClass]="rowClass">
	<label [for]="formElement.name" [ngClass]="labelClass">
		{{formElement.label}}
		<span class="mandatoryColor" *ngIf="(formElement.label) && (formElement.required) && !formElement.silentRequired">*</span>
	</label>
	<div [ngClass]="inputClass">
		<div class="row">
			<div class="col-md-8">
				<input [disabled]="isDisabled()" (keydown)="onKeydown($event)" [attr.maxlength]="formElement.maxFieldLength" (blur)="onBlur()"
				[class]="FORM_STYLE_CONFIG.formGroup.portlet.body.section.body.inputElement.element.input.default" [id]="formElement.id || formElement.name || name" [type]="type" [placeholder]="formElement.placeholder"
				[name]="name ||formElement.name" [(ngModel)]="value.aadharNumber" (ngModelChange)="onChange()">
				<span *ngIf="formElement.metainfo">
					{{formElement.metainfo}}
				</span>
			</div>
			<div class="col-md-3" *ngIf="!aadharVerified; else showValidated">
				<button [disabled]="!validAadharChecksum" type="button" class="btn btn-next" (click)="validateAdhar()">
					Verify
				</button>
			</div>
			<ng-template #showValidated>
				<span style="color: green;">Verified</span>
			</ng-template>
		</div>

	</div>
	<ng-container *ngIf="!formElement.silentRequired">
		<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		</label>
		<div [ngClass]="inputClass || 'col-10'">
			<ng-content></ng-content>
		</div>
	</ng-container>
	<ng-container *ngIf="formElement.silentRequired">
		<label *ngIf="formElement.row" [for]="formElement.name" [ngClass]="labelClass">
		</label>
		<div class="min-height-20">

		</div>
	</ng-container>
</div>
